import { render, staticRenderFns } from "./PackLayer.vue?vue&type=template&id=cef975fc&"
import script from "./PackLayer.vue?vue&type=script&lang=js&"
export * from "./PackLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports